import api from "./api";
import {mapEmployeeProjectsDto} from "../dto/EmployeeProjectsDto";


export const createEmployeeProjectForUser = async (userId, dto) => {
    try {
        const res = await api.post(`/EmployeeProject/${userId}`, dto);
        return res.data;
    } catch (err) {
        console.error("Error creating EmployeeProject:", err);
        throw err;
    }
};

export async function updateEmployeeProject(projectId, dto) {
    const payload = {
        Title: dto.Title,
        StartDate: dto.StartDate,
        EndDate: dto.EndDate,
        Skills: dto.Skills,
        Description: dto.Description,
        SortOrder: dto.SortOrder,
    };

    return api.patch(`/EmployeeProject/${projectId}`, payload, {
        headers: {"Content-Type": "application/json"},
    });
}

export const deleteEmployeeProject = async (userId) => {
    try {
        const res = await api.delete(`/EmployeeProject/${userId}`);
        return res.data;
    } catch (err) {
        console.error("Error deleting Holiday:", err);
        throw err;
    }
};


export const getEmployeeProjectsForUser = async (userId) => {
    try {
        const url = `/EmployeeProject/${userId}`;
        const res = await api.get(url);
        return res.data.map(mapEmployeeProjectsDto);
    } catch (err) {
        console.error("Error getting employee project for User:", err);
        throw err;
    }
};